'use client'

import nextDynamic from 'next/dynamic'

const OperatorView = nextDynamic(() => import('./OperatorView'), { ssr: false })

export default function OperatorViewLoader({
  matchId,
  uid,
  enableGestureOverlay = false,
  experimentalMode = false,
}: {
  matchId: string
  uid: string
  enableGestureOverlay?: boolean
  experimentalMode?: boolean
}) {
  return <OperatorView matchId={matchId} uid={uid} enableGestureOverlay={enableGestureOverlay} experimentalMode={experimentalMode} />
}
